/** Expected resource absence rendered as a normal not-found state, not an incident. */
export class ExpectedNotFoundQueryError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ExpectedNotFoundQueryError';
  }
}

export function shouldCaptureQueryError(error: unknown): boolean {
  return !(error instanceof ExpectedNotFoundQueryError);
}

export function isAuthReadyForTenantQuery(
  isAuthenticated: boolean,
  tenantId: string | null | undefined,
): boolean {
  return isAuthenticated && Boolean(tenantId);
}
